<template>
  <div>
    <div class="mx-5 py-5 d-flex justify-space-between">
      <h5>Edit Courses</h5>
      <v-icon style="color: rgba(8, 8, 22, 0.6)" class="ml-8" @click="close()"
        >mdi-close</v-icon
      >
    </div>
    
    <v-card color="#F6F8FC" flat class="px-5">
      <v-form v-model="valid" class="py-4">
        <v-container class="">
          <span class="text-stl">Course of Training </span>
          <v-select
            class="pt-0"
            v-model="form.CourseId"
            :items="GetCourse"
            item-text="Title"
            item-value="Id"
            label="Select a Course"
            attach
            single-line
          ></v-select>
          <span class="text-stl">Trainer </span>
          <v-select
            class="pt-0"
            v-model="form.TrainerId"
            :items="GetAllInstructorsIDsAndNames"
            item-text="Name"
            item-value="Id"
            label="Select a Training Instructor"
            attach
            single-line
          ></v-select>
          <div>
            <span class="text-stl">Date Started </span>
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              :return-value.sync="form.DateStarted"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  hide-details
                  single-line
                  dense
                  v-model="form.DateStarted"
                  label=""
                  append-icon="mdi-calendar-range-outline"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="form.DateStarted" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu1 = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menu1.save(form.DateStarted)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </div>
          <div class="mt-4">
            <span class="text-stl">Date Graduated </span>
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              :return-value.sync="form.DateGraduated"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  hide-details
                  single-line
                  dense
                  v-model="form.DateGraduated"
                  label=""
                  append-icon="mdi-calendar-range-outline"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="form.DateGraduated" no-title scrollable :min="form.DateStarted">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu2 = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menu2.save(form.DateGraduated)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </div>
          <div class="mt-3">
            <span class="text-stl">Credential Earned </span>
            <v-select
              class="pt-2"
              v-model="form.CredentialEarned"
              :items="credentailsitems"
              label="Select Credentials"
              single-line
            ></v-select>
          </div>
        </v-container>
      </v-form>
      <div class="d-flex justify-end mt-3">
        <v-btn
          color="#C4C4C4"
          class="white--text py-5 px-8 mb-6"
          depressed
          @click="close()"
          ><span class="text_style">Cancel</span>
        </v-btn>
        <v-btn
          color="primary"
          class="white--text py-5 px-8 ml-4"
          depressed
          @click="save()"
          ><span v-if="btnloader != true"> Update </span>
          <v-progress-circular
            indeterminate
            size="20"
            v-else
            class="px-5"
            color="white"
            v-show="btnloader"
          ></v-progress-circular
        ></v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
// import VueDropify from "vue-dropify";
// import vue2Dropzone from "vue2-dropzone";
// import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapGetters } from "vuex";
export default {
  name: "",
  props: ["courseTaughtData"],
  components: {
    // VueDropify,
    // vueDropzone: vue2Dropzone,
  },
  computed: {
    ...mapGetters(["getCourseTaughtById", "GetLoggedInUser", "GetPreviewUser","GetInstructors","GetAllInstructorsIDsAndNames", "GetCoursesIDsAndTitle",
      "GetCourses",]),
      GetCourse(){
      return this.GetCoursesIDsAndTitle.filter(item => item.Visibility == true)
    }
  },
  data() {
    return {
      publishdate: "",
      graduatedate: "",
      menu2: false,
      menu1: false,
      select: { state: "Gillbert Sherry", abbr: "FL" },
      items: [
        { state: "Gillbert Sherry", abbr: "FL" },
        { state: "Florida", abbr: "" },
      ],
      credentailsitems: [" BAT", "CBI", "SrCBI", "CBI-A", "BrI", "MSI", "FFI"],
      btnloader: false,
      form: {
        Id: 0,
        CourseId: 0,
        TrainerId: 0,
        UserId: 0,
        DateStarted: "",
        DateGraduated: "",
        CredentialEarned: "",
        ModifiedBy: 0,
      },
    };
  },
  mounted() {
    if (this.courseTaughtData) {
      this.$store
        .dispatch("GetCourseTaughtById", this.courseTaughtData.Id)
        .then(() => {
          this.form.Id = this.getCourseTaughtById[0].Id;
          this.form.CourseId = this.getCourseTaughtById[0].Course.Id;
          this.form.TrainerId = this.getCourseTaughtById[0].Instructor.Id;
          this.form.UserId = this.GetPreviewUser.Id;
          this.form.DateStarted = this.getCourseTaughtById[0].DateStarted?.split("T")[0];
          this.form.DateGraduated = this.getCourseTaughtById[0].DateGraduated?.split("T")[0];
          this.form.CredentialEarned = this.getCourseTaughtById[0].CredentialEarned;
          this.form.ModifiedBy = this.GetLoggedInUser.Id;
        });
    }
    if(this.GetAllInstructorsIDsAndNames.length === 0){
      this.$store.dispatch("GetAllInstructorsIDsAndNames");
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save() {
      this.btnloader = true;
      this.$store.dispatch("EditCourseTaught",this.form).then(()=>{
        this.close();
        this.btnloader = false;
      })
      // setTimeout(() => {
      // }, 100);
      // setTimeout(() => {
      //   this.snackbar = true;
      // }, 2000);
    },
  },
};
</script>

<style scoped>
.vue-dropzone {
  padding: 0;
  background: transparent;
  border-style: dashed;
}
.text-stl {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #0d0d0d;
}
</style>
